module.exports = __webpack_public_path__ + "img/movies.89be2bdd.jpeg";